import PropTypes from 'prop-types';
import React from 'react';
import backgroundLeft from '../../assets/auth/background-left.png';
import backgroundRight from '../../assets/auth/background-right.png';
import backgroundTop from '../../assets/auth/background-top.png';
import teamworkLower from '../../assets/auth/teamwork-lower.png';
import teamworkUpper from '../../assets/auth/teamwork-upper.png';
import styles from './auth.module.scss';
import AuthFormContainer from './formContainer.auth';

const bgImages = [
  {
    id: 'background-top',
    className: 'background-top',
    alt: 'background-top',
    src: backgroundTop,
  },
  {
    id: 'background-left',
    className: 'background-left',
    alt: 'background-left',
    src: backgroundLeft,
  },
  {
    id: 'background-right',
    className: 'background-right',
    alt: 'background-right',
    src: backgroundRight,
  },
  {
    id: 'background-lower',
    className: 'teamwork-lower',
    alt: 'teamwork-lower',
    src: teamworkLower,
  },
  {
    id: 'background-upper',
    className: 'teamwork-upper',
    alt: 'teamwork-upper',
    src: teamworkUpper,
  },
];

const AuthPage = () => {
  return (
    <>
      {bgImages.map((e) => (
        <img className={styles[e.className]} key={e.id} alt={e.id} id={e.id} src={e.src} />
      ))}

      <AuthFormContainer />
    </>
  );
};

export default AuthPage;
